<template>
  <el-drawer title="已入库UDI码" :visible="visible" size="60%" :destroy-on-close="true"
             :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>{{ state==='YWC' ? '已入库UDI码': '入库UDI码' }}</div>
      <el-button @click="$emit('close')"> 返回</el-button>
    </div>
    <div class="card-shadown flex-container-between" style="margin-bottom: 12px">
      <div class="flex-container-start">
        <div style="width: 80px">物料名称:</div>
        <span> {{ productInfo.materialName }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">规格型号:</div>
        <span> {{ productInfo.specification }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">包装层级:</div>
        <span> {{ productInfo.packLevel }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">{{ state==='YWC' ? '已入库' : '数量' }}:</div>
        <span> {{ productInfo.inNumber }}</span>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between">
<!--      <div>
        <el-button v-if="state==='YWC'" size="mini" type="primary" @click="handleInvalid">
          作废UDI码
        </el-button>
      </div>-->
      <div style="display: flex">
        <el-input v-model.trim="queryParams.code" placeholder="UDI码" clearable style="width: 200px">
        </el-input>
        <div style="margin-left: 8px">
          <el-button size="mini" type="primary" @click="handleSearch">
            搜索
          </el-button>
        </div>
      </div>

    </div>

    <el-table ref="table" :data="udiDataList" height="500" style="width: 100%; margin-top: 12px"
              border stripe @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="code" label="UDI码" show-overflow-tooltip/>
      <el-table-column v-if="state==='YWC'" prop="createTime" label="入库时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.createTime ? formatDate(scope.row.createTime, 'yyyy-MM-dd hh:mm:ss') : null }}
        </template>
      </el-table-column>
<!--      <el-table-column v-if="state==='YWC'" prop="state" label="状态" width="130">
        <template slot-scope="scope">
          <dict-tag :options="dictObj.receiptDeliveryState" :value="scope.row.state" />
        </template>
      </el-table-column>-->
      <el-table-column v-if="productInfo.isBatchCode" prop="number" label="数量" width="130"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="handlePreview(scope.row)">查看内层UDI</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" style="margin-top: 24px" :total="total" :page-sizes="[10,50, 100, 300]"
                :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>
    <InnerLayerUdiDialog v-if="previewVisible" :visible="previewVisible" :complete-udi="completeUdi" @close="previewVisible=false"></InnerLayerUdiDialog>
    <InvalidUdiDialog
      v-if="invalidShow"
      :visible="invalidShow"
      :list="selectList"
      :is-batch-code="productInfo.isBatchCode"
      @close="invalidShow=false"
      @getList="getList"
    />
  </el-drawer>
</template>

<script>
import InnerLayerUdiDialog from "@/components/InnerLayerUdiDialog";
import {formatDate} from '@/utils/date.js'
import {getStockInCodeList, handleInvalidUdiCode } from "@/api/warehousingOrder";
import InvalidUdiDialog from "@/views/outboundManage/components/previewUdi/InvalidUdiDialog.vue";

export default {
  name: 'WarehoseUdiReview',
  components: { InvalidUdiDialog, InnerLayerUdiDialog},
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    dictObj:{
      type:Object,
      default:()=>{
        return {
          receiptDeliveryState:[]
        }
      }
    },
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    state: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data: () => {
    return {
      formatDate,
      udiDataList: [], // 列表数据
      selectList: [],// 选中列表
      queryParams: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        inProductId: '',
        code: '',
      },
      loading: false, // 是否显示遮罩
      previewVisible: false, // 查看详情
      total: 0, // 总条数
      completeUdi: '', // 查看详情数据
      invalidShow: false,
    }
  },
  mounted() {
    this.queryParams.inProductId = this.productInfo.id
    this.getList()
  },
  methods: {
    handlePreview(row) {
      if (this.productInfo.isBatchCode) {
        this.$message({type: 'warning', message: '当前UDI码为批次码，无关联关系！'})
        return
      }
      this.previewVisible = true
      this.completeUdi = row.code
    },
    // 处理udi作废
    handleInvalid() {
      if (this.selectList.length === 0) {
        this.$message({type: 'warning', message: '请选择要报废的UDI码!'})
        return false
      } else {
        this.invalidShow = true;
        // this.$confirm('确认作废选中的UDI码吗?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.loading = true
        //   handleInvalidUdiCode(this.selectList).then(() => {
        //     this.$message({type: 'success', message: '操作成功!'})
        //     this.getList()
        //   }).finally(() => {
        //     this.loading = false
        //   })
        // })
      }
    },
    // 处理选择
    handleSelectionChange(valList) {
      this.selectList = valList
    },
    // 搜索
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    // 获取列表数据
    getList() {
      // 获取生产任务列表数据
      this.loading = true // 打开遮罩
      const params = JSON.parse(JSON.stringify(this.queryParams))
      getStockInCodeList(params)
        .then((res) => {
          this.udiDataList = res.rows
          this.total = res.total
        })
        .finally(() => {
          this.loading = false // 关闭遮罩
        })
    }
  }
}
</script>

